import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { components } from "react-select";
import ChipIcon from "../../../../../Chip/components/ChipIcon";
import { BaseChip } from "../../../../../Chip/styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MultiValueContainer = components.MultiValueContainer;
function ChipMultiValueContainer(props) {
  var data = props.data;
  var iconProps = data.iconProps,
    onClick = data.onClick,
    isDisabled = data.isDisabled;
  return /*#__PURE__*/_jsxs(BaseChip, {
    size: "default",
    isInteractive: Boolean(onClick),
    onClick: onClick,
    reduceLeftPadding: Boolean(iconProps),
    isDisabled: isDisabled,
    children: [iconProps && /*#__PURE__*/_jsx(ChipIcon, _extends({}, iconProps)), /*#__PURE__*/_jsx(MultiValueContainer, _extends({}, props))]
  });
}
export default ChipMultiValueContainer;